
	import { defineComponent, getCurrentInstance, ref, onMounted } from 'vue'
	import { useTableScroll } from '@/common/mixins/useTableScroll'
	import { delTemplate, getTemplateList } from './request'
	import { message, Modal } from 'ant-design-vue'

	const columns = [
		{
			title: 'ID',
			dataIndex: 'templateId',
			key: 'templateId'
		},
		{
			title: '创建时间',
			dataIndex: 'createTime',
			key: 'createTime'
		},
		{
			title: '版本号',
			dataIndex: 'version',
			key: 'version'
		},
		{
			title: '描述',
			dataIndex: 'desc',
			key: 'desc'
		},
		{
			title: '操作',
			slots: { customRender: 'action' },
			slot: 'action'
		}
	]
	export default defineComponent({
		setup() {
			const instance = getCurrentInstance()
			const { scroll } = useTableScroll(instance)

			const tableData = ref([])

			const fetchList = async () => {
				try {
					const { data } = await getTemplateList()
					tableData.value = data
				} catch (e) {
					console.error(e)
				}
			}

			const delTemplateAction = async (id) => {
				Modal.confirm({
					title: '确认提示',
					content: "确认删除模板？",
					okText: '确认',
					cancelText: '取消',
					onOk: async () => {
						try {
							await delTemplate({ templateId: id })
							fetchList()
							message.success('删除成功')
						} catch (e) {
							console.error(e)
						} 
					}
				})
			}

			onMounted(() => {
				fetchList()
			})
			return {
				scroll,
				columns,
				tableData,
				delTemplateAction
			}
		}
	})
